export const columns = (onHeaderClick: (accessor: string) => void) => [
  {
    Header: "Title",
    accessor: "title",
    onHeaderClick: () => onHeaderClick("title"),
  },
  {
    Header: "Slug",
    accessor: "slug",
    onHeaderClick: () => onHeaderClick("slug"),
  },
];
